import CategoryListClassicDesktop from './category-list-classic-desktop';
import CategoryListClassicMobile from './category-list-classic-mobile';
import forDevice from '../../hoc/for-device';

export default forDevice(CategoryListClassicMobile, CategoryListClassicDesktop);
